import { useQuery } from "@tanstack/react-query";
import { getDepartmentById } from "../../api/apiDepartments";
import i18next from "i18next";

/**
 * Hook لجلب بيانات قسم معين بواسطة معرفه
 * @param {number|string} id - معرف القسم
 */
export function useGetDepartmentById(id) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["department", id, i18next.language],
        queryFn: () => getDepartmentById(id),
        enabled: !!id,
        retry: false,
    });

    const department = data?.data || null;

    return { isLoading, error, department, refetch };
}
